import {HTTP} from "../../../libs/HTTP"

class CategoriesApi {
    uriPrefix = "/api/categories";

    getCategories(){
        return HTTP.get(this.uriPrefix)
            .then(response => response.data)
    }

    createCategory(data){
        return HTTP.post(this.uriPrefix, data)
            .then(response => response.data)
    }

    updateCategory(data){
        return HTTP.put(this.uriPrefix, data)
            .then(response => response.data)
    }
    
    getCategory(id) {
        return HTTP.get(this.uriPrefix + `/${id}`)
            .then(response => response.data)
    }

    deleteCategory(id) {
        return HTTP.delete(this.uriPrefix + `/${id}`)
            .then(response => response.data)
    }

}
const categoriesApi = new CategoriesApi();
export default categoriesApi;